import { Container, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom'

function Disclaimer() {
    const location = useLocation()
    return (
        <Container maxWidth={'lg'} sx={{ pt: 4, minHeight: '70vh' }}>
            <Typography variant='h4' component={'h4'} mb={3} textTransform={'none'}>
                {location?.pathname == '/termsOfService' ? 'Terms of Services' : location?.pathname == '/disclaimer' ? 'Disclaimer' : location?.pathname == '/privacyPolicy' ? 'Privacy Policy' : location?.pathname == '/releaseMyCash' ? 'Release my Cash' : location?.pathname == '/investInInvoices' ? 'Invest in Invoices' : location?.pathname == '/fundYourBuiseness' ? 'Fund Your Business' : location?.pathname == '/beAFunder' ? 'Be a Funder' : 'Contact Us'}
            </Typography>
            <Typography variant='p' component={'p'}>
                What is Lorem Ipsum?
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </Typography>
        </Container>
    )
}

export default Disclaimer